import React from "react";
import styled, { keyframes } from "styled-components";
import Photo from "../assets/PassportIM/Photo.jpg";

const PreviewPassport = () => {
  const handlePrint = () => {
    window.print();
  };

  return (
    <Wrapper>
      <Header className="no-print">
        <h1>भारत गणराज्य REPUBLIC OF INDIA</h1>
        <h2>Passport Preview Details</h2>
      </Header>

      <Card className="print-area">
        <TopSection>
          <PhotoWrapper>
            <img src={Photo} alt="Passport" />
          </PhotoWrapper>
          <SignatureWrapper>
            <img src={Photo} alt="Signature" />
          </SignatureWrapper>
        </TopSection>

        <DetailsGrid>
          <Detail>
            <strong>Type:</strong> <span>P</span>
          </Detail>
          <Detail>
            <strong>Country Code:</strong> <span>IND</span>
          </Detail>
          <Detail>
            <strong>Passport No:</strong> <span>GC52367</span>
          </Detail>
          <Detail>
            <strong>Surname:</strong> <span>TUBAKALE</span>
          </Detail>
          <Detail>
            <strong>Given Name:</strong> <span>SANJAY DNYOBA</span>
          </Detail>
          <Detail>
            <strong>Nationality:</strong> <span>INDIAN</span>
          </Detail>
          <Detail>
            <strong>Sex:</strong> <span>M</span>
          </Detail>
          <Detail>
            <strong>Date of Birth:</strong> <span>01/04/1975</span>
          </Detail>
          <Detail>
            <strong>Place of Birth:</strong>{" "}
            <span>CHILVANTWADI, MAHARASHTRA</span>
          </Detail>
          <Detail>
            <strong>Place of Issue:</strong> <span>Pune</span>
          </Detail>
          <Detail>
            <strong>Date of Issue:</strong> <span>10/12/2024</span>
          </Detail>
          <Detail>
            <strong>Date of Expiry:</strong> <span>9/12/2034</span>
          </Detail>
          <Detail>
            <strong>Father's Name:</strong> <span>DNYANOBA TUBAKALE</span>
          </Detail>
          <Detail>
            <strong>Mother's Name:</strong> <span>SMITABAI TUBAKALE</span>
          </Detail>
          <Detail>
            <strong>Spouse's Name:</strong> <span>MADHURI SANJAY TUBAKALE</span>
          </Detail>
          <Detail>
            <strong>Address:</strong>
            <span>
              ADITYA NIWAS, AUSA ROAD, BLOCK NO 9, LATUR, LATUR, PIN: 413531,
              MAHARASHTRA, INDIA
            </span>
          </Detail>
          <Detail>
            <strong>File No:</strong> <span>NGP02345687869</span>
          </Detail>
        </DetailsGrid>
      </Card>

      <ActionWrapper className="no-print">
        <PrintButton onClick={handlePrint}>Print Passport Card</PrintButton>
      </ActionWrapper>

      <Footer className="no-print">
        Passport Service Webapp By Sudhanshu Gaikwad
      </Footer>
    </Wrapper>
  );
};

export default PreviewPassport;
const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
`;

const Wrapper = styled.div`
  max-width: 800px;
  margin: 2rem auto;
  padding: 2rem;
  background: #1c1c1c;
  border-radius: 8px;
  color: #eee;
  animation: ${fadeIn} 0.4s ease-in-out;
  font-family: "Segoe UI", sans-serif;

  @media print {
    background: white;
    color: black;
    padding: 0;
    margin: 0;
  }
`;

const Header = styled.div`
  text-align: center;
  margin-bottom: 1rem;

  h1 {
    font-size: 1.5rem;
  }

  h2 {
    font-size: 1rem;
    color: #ccc;
  }
`;

const Card = styled.div`
  padding: 1.5rem;
  border: 1px solid #444;
  background: #121212;
  border-radius: 10px;

  @media print {
    border: none;
    background: white;
    color: black;
    padding: 0;
  }
`;

const TopSection = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;
  flex-wrap: wrap;

  img {
    border: 1px solid #666;
    object-fit: cover;
  }
`;

const PhotoWrapper = styled.div`
  img {
    width: 120px;
    height: 150px;
  }
`;

const SignatureWrapper = styled.div`
  img {
    width: 120px;
    height: 40px;
    margin-top: auto;
  }
`;

const DetailsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 1rem;
`;

const Detail = styled.div`
  background: #1f1f1f;
  padding: 0.75rem;
  border-radius: 6px;
  font-size: 0.9rem;
  border: 1px solid #333;

  strong {
    display: block;
    color: #00ffc8;
  }

  span {
    margin-top: 4px;
    display: block;
  }

  @media print {
    background: white;
    border: none;
    padding: 0.25rem;
    strong {
      color: black;
    }
  }
`;

const ActionWrapper = styled.div`
  margin-top: 2rem;
  text-align: center;
`;

const PrintButton = styled.button`
  padding: 0.75rem 1.5rem;
  background: linear-gradient(to right, #00c9ff, #92fe9d);
  color: black;
  font-weight: bold;
  border: none;
  border-radius: 6px;
  cursor: pointer;

  &:hover {
    transform: scale(1.02);
  }
`;

const Footer = styled.footer`
  text-align: center;
  margin-top: 2rem;
  font-size: 0.85rem;
  color: #888;
`;

/* Hide everything except print-area when printing */
const style = document.createElement("style");
style.innerHTML = `
  @media print {
    .no-print { display: none !important; }
    .print-area { display: block !important; }
  }
`;
document.head.appendChild(style);
